import styled from '@emotion/styled';
import { LegendBaseProps } from './ChartLegend';
import { Palette } from '@mui/material';
import { MatrixedChartValues } from '../chartUtils';

export interface TileLegendProps extends LegendBaseProps {}

const TileLegend = ({ data, colors, mouseOverCallback, mouseLeaveCallback }: TileLegendProps) => {
  const lines = data.values as MatrixedChartValues[];
  return (
    <Legend>
      {lines.map((lineData, index) => (
        <LegendItem
          color={data.colors[index]}
          key={`${lineData.label.toLowerCase().replace(/\s+/g, '-')}-legend-item`}
          onMouseOver={() => mouseOverCallback(index)}
          onMouseLeave={() => mouseLeaveCallback()}
        >
          <Number>{lineData.data.reduce((acc, curr) => acc + curr, 0)}</Number>
          <Label>{lineData.label}</Label>
        </LegendItem>
      ))}
    </Legend>
  );
};

export default TileLegend;

const Legend = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(1)};
  width: fit-content;
`;

const LegendItem = styled.div<{ color: any }>`
  width: 200px;
  background: ${({ theme, color }) => {
    return color.startsWith('#') ? color + '4a' : theme.palette[color as keyof Palette].main + '3a';
  }};
  border: 1px solid
    ${({ theme, color }) => {
      return color.startsWith('#') ? color : theme.palette[color as keyof Palette].main + '9a';
    }};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: ${({ theme }) => theme.spacing(1, 0)};
  text-align: center;
  cursor: default;
  transition: transform 0.2s ease-in-out, background 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
    background: ${({ theme, color }) => {
      return color.startsWith('#') ? color + '4a' : theme.palette[color as keyof Palette].main + '5a';
    }};
  }
`;

const Number = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`;

const Label = styled.div`
  font-size: 0.9rem;
  font-weight: 400;
  text-align: center;
`;
